import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { flattenDeep } from 'lodash';
import { ROOT_CATALOG_ID } from 'constants/catalog';

const transformCatalogLanding = landing => {
  if (!landing) return null;
  return {
    imageUrl: landing.image_url,
    itemsRemaining: landing.items_remaining
  };
};

function isCatalogPhotoDto(value) {
  return 'url' in value;
}

export const transformCatalogDto = catalog => {
  const {
    id,
    title,
    code,
    url,
    url_en,
    photo,
    order,
    depth
  } = catalog;
  return {
    id,
    title,
    code,
    url,
    photo: isCatalogPhotoDto(photo) ? photo : null,
    urlEn: url_en,
    order,
    depth: depth || 0,
    isShippable: catalog.shippable,
    isColorAvailable: !!catalog.color_field_visibility,
    isLocationAvailable: catalog.location_field_visible,
    isSizesAvailable: !!catalog.size_field_visibility,
    isVideoGameRatingAvailable: !!catalog.video_game_rating_field_visibility,
    isBrandsAvailable: !!catalog.brand_field_visibility,
    isIsbnAvailable: !!catalog.isbn_field_visibility,
    isAuthorAvailable: !!catalog.author_field_visibility,
    isMeasurementsAvailable: !!catalog.measurements_field_visibility,
    isBookTitleAvailable: !!catalog.book_title_field_visibility,
    landing: transformCatalogLanding(catalog.landing),
    canBrowseSubcategories: catalog.allow_browsing_subcategories,
    restrictedToStatusId: catalog.restricted_to_status_id,
    unisexCatalogId: catalog.unisex_catalog_id,
    catalogIds: catalog.catalogs.map(item => item.id),
    sizeGroupId: catalog.size_group_id,
    sizeGroupIds: catalog.size_group_ids,
    itemCount: catalog.item_count,
    catalogs: catalog.catalogs.map(dto => transformCatalogDto(dto))
  };
};
export const transformCatalogDtoList = catalogList => {
  return catalogList.map(transformCatalogDto);
};

const catalogTree = function (catalogs) {
  let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return catalogs.map(catalog => {
    const catalogWithDepth = _objectSpread(_objectSpread({}, catalog), {}, {
      depth
    });

    return [catalogWithDepth, ...catalogTree(catalog.catalogs, depth + 1)];
  });
};

const flattenCatalogDtos = catalogs => flattenDeep(catalogTree(catalogs));

const applyParentId = (catalog, index, catalogs) => {
  const parent = catalogs.find(it => it.catalogIds.includes(catalog.id));
  const parentId = parent ? parent.id : ROOT_CATALOG_ID;
  return _objectSpread(_objectSpread({}, catalog), {}, {
    parentId
  });
};

export const transformCatalogDtos = catalogs => flattenCatalogDtos(catalogs).map(transformCatalogDto).map(applyParentId);
export const getCatalogByCounts = (catalogs, catalogCounts) => catalogs.reduce((accumulator, catalog) => {
  let filteredChildren = [];
  let childrenItemSum = 0;

  if (catalog.catalogs.length) {
    const childrenCounts = getCatalogByCounts(catalog.catalogs, catalogCounts);
    filteredChildren = childrenCounts.catalogs;
    childrenItemSum = childrenCounts.count;
  }

  if (catalogCounts[catalog.id] || filteredChildren.length) {
    const itemCount = childrenItemSum + (catalogCounts[catalog.id] || 0);
    accumulator.catalogs.push(_objectSpread(_objectSpread({}, catalog), {}, {
      catalogs: filteredChildren,
      item_count: itemCount
    }));
    accumulator.count += itemCount;
  }

  return accumulator;
}, {
  catalogs: [],
  count: 0
});
export const transformCatalogDtosWithCounts = (catalogs, catalogCounts) => {
  const counts = catalogCounts.reduce((acc, _ref) => {
    let {
      id,
      count
    } = _ref;
    return _objectSpread(_objectSpread({}, acc), {}, {
      [id]: count
    });
  }, {});
  const catalogsWithCounts = getCatalogByCounts(catalogs, counts).catalogs;
  return transformCatalogDtos(catalogsWithCounts);
};